import { render } from "./ProjectSiteClassmateShow.vue?vue&type=template&id=35b7a742&scoped=true"
import script from "./ProjectSiteClassmateShow.vue?vue&type=script&lang=js"
export * from "./ProjectSiteClassmateShow.vue?vue&type=script&lang=js"

import "./ProjectSiteClassmateShow.vue?vue&type=style&index=0&id=35b7a742&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b7a742"],['__file',"src/views/h5/luqiao/display/ProjectSiteClassmateShow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35b7a742"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35b7a742', __exports__)) {
    api.reload('35b7a742', __exports__)
  }
  
  module.hot.accept("./ProjectSiteClassmateShow.vue?vue&type=template&id=35b7a742&scoped=true", () => {
    api.rerender('35b7a742', render)
  })

}


export default __exports__